import apiClient from '../../../lib/axios';

export const fetchCountries = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
  if (filters.search) params.append('search', filters.search);
  if (filters.page) params.append('page', filters.page);
  if (filters.limit) params.append('limit', filters.limit);
  const response = await apiClient.get(`/api/locations/countries?${params.toString()}`);
  return response.data;
};

export const createCountry = async (payload) => {
  const response = await apiClient.post('/api/locations/countries', payload);
  return response.data;
};

export const updateCountry = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/locations/countries/${id}`, payload);
  return response.data;
};

export const deleteCountry = async (id) => {
  const response = await apiClient.delete(`/api/locations/countries/${id}`);
  return response.data;
};

export const fetchZones = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.country) params.append('country', filters.country);
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
  if (filters.search) params.append('search', filters.search);
  if (filters.page) params.append('page', filters.page);
  if (filters.limit) params.append('limit', filters.limit);
  const response = await apiClient.get(`/api/locations/zones?${params.toString()}`);
  return response.data;
};

export const createZone = async (payload) => {
  const response = await apiClient.post('/api/locations/zones', payload);
  return response.data;
};

export const updateZone = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/locations/zones/${id}`, payload);
  return response.data;
};

export const deleteZone = async (id) => {
  const response = await apiClient.delete(`/api/locations/zones/${id}`);
  return response.data;
};

export const fetchRegions = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.zone) params.append('zone', filters.zone);
  if (filters.country) params.append('country', filters.country);
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
  if (filters.search) params.append('search', filters.search);
  if (filters.page) params.append('page', filters.page);
  if (filters.limit) params.append('limit', filters.limit);
  const response = await apiClient.get(`/api/locations/regions?${params.toString()}`);
  return response.data;
};

export const createRegion = async (payload) => {
  const response = await apiClient.post('/api/locations/regions', payload);
  return response.data;
};

export const updateRegion = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/locations/regions/${id}`, payload);
  return response.data;
};

export const deleteRegion = async (id) => {
  const response = await apiClient.delete(`/api/locations/regions/${id}`);
  return response.data;
};

export const fetchDistricts = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.region) params.append('region', filters.region);
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
  if (filters.search) params.append('search', filters.search);
  if (filters.page) params.append('page', filters.page);
  if (filters.limit) params.append('limit', filters.limit);
  const response = await apiClient.get(`/api/locations/districts?${params.toString()}`);
  return response.data;
};

export const createDistrict = async (payload) => {
  const response = await apiClient.post('/api/locations/districts', payload);
  return response.data;
};

export const updateDistrict = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/locations/districts/${id}`, payload);
  return response.data;
};

export const deleteDistrict = async (id) => {
  const response = await apiClient.delete(`/api/locations/districts/${id}`);
  return response.data;
};

export const fetchWards = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.district) params.append('district', filters.district);
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
  if (filters.search) params.append('search', filters.search);
  if (filters.page) params.append('page', filters.page);
  if (filters.limit) params.append('limit', filters.limit);
  const response = await apiClient.get(`/api/locations/wards?${params.toString()}`);
  return response.data;
};

export const createWard = async (payload) => {
  const response = await apiClient.post('/api/locations/wards', payload);
  return response.data;
};

export const updateWard = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/locations/wards/${id}`, payload);
  return response.data;
};

export const deleteWard = async (id) => {
  const response = await apiClient.delete(`/api/locations/wards/${id}`);
  return response.data;
};

export const bulkUploadDemographicsLocations = async ({
  rows,
  updateExisting = true,
  dryRun = false,
} = {}) => {
  const response = await apiClient.post('/api/locations/bulk-upload/demographics', {
    rows,
    updateExisting,
    dryRun,
  });
  return response.data;
};

export const fetchVenues = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.country) params.append('country', filters.country);
  if (filters.region) params.append('region', filters.region);
  if (filters.district) params.append('district', filters.district);
  if (filters.ward) params.append('ward', filters.ward);
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
  if (filters.search) params.append('search', filters.search);
  if (filters.page) params.append('page', filters.page);
  if (filters.limit) params.append('limit', filters.limit);
  const response = await apiClient.get(`/api/locations/venues?${params.toString()}`);
  return response.data;
};

export const createVenue = async (payload) => {
  const response = await apiClient.post('/api/locations/venues', payload);
  return response.data;
};

export const updateVenue = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/locations/venues/${id}`, payload);
  return response.data;
};

export const deleteVenue = async (id) => {
  const response = await apiClient.delete(`/api/locations/venues/${id}`);
  return response.data;
};
